<script setup>
import {computed} from 'vue'
import {useFormStore} from '@/stores/form'
import ImageSelection from '@/common/ImageSelection'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
})

// Dynamic Pinia Store
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// Computed properties
const fileId = computed(() => {
    return props.currentData?.[props.field.name]
})

const tableName = computed(() => {
    return formStore.value?.tableName
})

// Methods
const onChange = (item) => {
    props.currentData[props.field.name] = item.id

    // todo - This should probably be a directive that updates
    // this.currentData.title when fieldData.fileName changes.
    if (
        (tableName.value === 'm_images' || tableName.value === 'documents') &&
        props.currentData.title === ''
    ) {
        props.currentData.title = item.fileName
    }
}

// Emulating the created hook logic via Pinia action
if (typeof props.currentData[props.field.name] === 'undefined') {
    formStore.value?.presetData({
        name: props.field.name,
        value: 0,
    })
}
</script>

<template>
    <ImageSelection :form-id="formId" :column-name="field.name" :file-browser="true" :file-id="fileId"
                    :on-change="onChange" :remove-option="true" :row-id="currentData.id" :table-name="tableName"
                    :readonly="field.readonly"/>
</template>